import { IBaseModel } from '@/bundles/App/interfaces';

export default class BaseModel implements IBaseModel {
  created: Date;
  id: number;
  updated: Date;

  constructor (props: IBaseModel) {
    this.created = props.created;
    this.id = props.id;
    this.updated = props.updated;
  }
}
